import { useState } from 'react';
import {
  AuthPanel,
  ChangePasswordForm,
  ChangePasswordFormValues,
} from '@nbirl/nbi-common-ui-libs';

import { useAuth } from '../../../shared/context';
import { useErrorToast } from '../../../shared/hooks';

export const ChangeTemporaryPassword = ({ email }: { email: string }) => {
  const { completeNewPassword, signOut } = useAuth();
  const [isPending, setIsPending] = useState(false);
  const { showErrorToast } = useErrorToast();

  const handleSubmit = async ({ newPassword }: ChangePasswordFormValues) => {
    try {
      setIsPending(true);
      await completeNewPassword(newPassword);
    } catch (error: any) {
      setIsPending(false);
      showErrorToast(error);
    }
  };

  return (
    <AuthPanel>
      <ChangePasswordForm
        showBackButton
        email={email}
        isPending={isPending}
        onSubmit={handleSubmit}
        onBack={() => signOut()}
      />
    </AuthPanel>
  );
};
